import {AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import { Imovel } from './models/imovel.model';
import {ActivatedRoute, Router} from '@angular/router';
import * as _ from 'lodash';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {DecimalPipe, formatCurrency} from '@angular/common';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AllImoveis} from '../core/services/all-imoveis.service';
import {MASKS} from 'ng-brazil';
import {doc, docSnapshots, Firestore} from '@angular/fire/firestore';
import {PATH_AUTOCOMPLETE} from '../core/utils/constants.util';
import {distinctUntilChanged, map, take} from 'rxjs/operators';
import {OwlOptions} from 'ngx-owl-carousel-o';
import {getFormattedPrice, toArea, toBath, toDormis, toSalas, toVaga} from '../core/utils/imovel.util';
import {CustomSearchComponent} from '../core/components/custom-search/custom-search.component';
import { SearchSidebarComponent } from '../core/components/search-sidebar/search-sidebar.component';
import {CustomSearchType} from '../core/components/custom-search/custom-search.enum';
import { IQuery } from '../core/components/models/IFormData';
import IAutoComplete from '../core/types/IAutoComplete';
import { Subscription } from 'rxjs';

// LOCAL STORAGE
const nextscroll = 'nextscroll';
const nextLastAllImoveis = 'nextLastAllImoveis';
const nextLastImoveis = 'nextLastImoveis';
const nextQueryParams = 'nextQueryParams';
const nextCurrentPage = 'nextCurrentPage';

@Component({
  selector: 'app-imoveis',
  templateUrl: './imoveis.component.html',
  styleUrls: ['./imoveis.component.scss']
})
export class ImoveisComponent implements OnInit, AfterViewInit {

  pages: number = 0;
  currentPage: number = 1;
  limitPosts: number = 10;
  params: any = {};
  category: string = ""
  collectionSize: number = 0;
  backing = false;
  order: 'default' | 'price' = 'default';

  initializeResults = false;

  MASKS = MASKS;

  _imoveis: Imovel[] = [];
  set imoveis(imoveis: Imovel[]) {
    this._imoveis = imoveis;
  }

  get imoveis() {
    return this._imoveis;
  }

  allImoveis: Imovel[] = [];

  simpleSearch: string = '';

  locais: any[];

  badges = [];

  queryParams: any = {};

  breadcrumbTitle: string = null;

  mySlideOptions: OwlOptions = {
    items: 1, dots: true, nav: false, navText: ['<', '>'],
  };

  autocompletes: any[] = [];
  autocompleteSelected: any = null;

  bairrosAndCidades: {
    condominios: IAutoComplete[],
    ruas: IAutoComplete[],
    bairros: IAutoComplete[],
    cidades: IAutoComplete[],
    visible: boolean
  } = {
    visible: false,
    bairros: [],
    cidades: [],
    condominios: [],
    ruas: [],
  };

  toSalas = toSalas;
  toDormis = toDormis;
  toArea = toArea;
  toBath = toBath;
  toVaga = toVaga;
  getFormattedPrice = getFormattedPrice;

  @ViewChild('customSearch') customSearch: CustomSearchComponent;
  @ViewChild('searchSidebar') searchSidebar: SearchSidebarComponent;

  constructor(
    private route: ActivatedRoute,
    private ngxService: NgxUiLoaderService,
    private all: AllImoveis,
    private router: Router,
    private modalService: NgbModal,
    private firestore: Firestore,
    private cdr: ChangeDetectorRef
  ) {
  }

  subQuery:Subscription;
  subImoveis:Subscription;
  ngOnInit() {
    this.all.autocomplete$.subscribe((data) => {
      // console.log(data.filter(d => d.type === 'condominio'));
      this.autocompletes = data; // Atualizando o array local
      this.cdr.detectChanges(); // Força o Angular a re-renderizar
    });

    // this.subImoveis = this.all.imoveis$.subscribe((imoveis:Imovel[]) => {
    //   this.imoveis = imoveis;
    // })

    // Buscando imoveis
    // this.all.getAllImoveisForFilter().subscribe((event) => {
    //   this.allImoveis = event;
    //   this.initObservableQuerys();
    // });
    this.initObservableQuerys();
  }

  private initObservableQuerys():void {
    this.subQuery = this.route.queryParams.subscribe(params => {
      const tipos = params.tipos ? Array.isArray(params.tipos) ? [...params.tipos] : [params.tipos] : [];
      this.order = params?.order ? params.order : 'default';
      // console.log()
      if(params.categoria && this.category !== params.categoria){
        // console.log("Categoria encontrada")
        this.category = params.categoria
      }
      this.params = {
        ...params,
        ...(tipos.length > 0 && { tipos })
      };
      localStorage.setItem("results", JSON.stringify(this.params));
      this.logn_localFilter();
    });
  }

  updateCategoryParam(newValue:string){
    this.category = newValue
  }

  private logn_localFilter(){
    this.logn_formInputValues()
    this.subImoveis = this.all.imoveis$.subscribe((imoveis:Imovel[]) => {
      if(imoveis.length > 0){
        // console.log(imoveis)
        let result:Imovel[] = this.filteredImoveis(imoveis);
        result = this.verifyParams(result);

        const storage: string = localStorage.getItem("results");
        const objStorage = JSON.parse(storage) || {};

        this.collectionSize = result.length;
        this.currentPage = (objStorage?.page) ? Number(objStorage.page) : 1;
        this.pages = Math.ceil(result.length / this.limitPosts);
        const init: number = (this.currentPage * this.limitPosts) - this.limitPosts;


        this.imoveis = result.slice(init, init + this.limitPosts);
        this.initializeResults = this.imoveis.length === 0;

        setTimeout(()=> {
          const scrollPosition:null | string = localStorage.getItem(nextscroll);
          if(scrollPosition){
            const top:number = Number.parseInt(scrollPosition);
            scroll({
              top
            })
            localStorage.removeItem(nextscroll);
          }
        }, 300)
      }
    })
  }

  private filteredImoveis(imoveis:Imovel[]): Imovel[]{
    let result:Imovel[];
    const finalidade = this.params?.finalidade ? this.params.finalidade.toLowerCase() : null;
    const categoria = this.params?.categoria ? this.params.categoria.toLowerCase() : null;

    // verificando finalidade
    if(finalidade && (finalidade === "residencial" || finalidade === "comercial")){
      result = imoveis.filter((im) => im.finalidade.toLowerCase() === finalidade);
    } else {
      result = imoveis;
    }

    // 'comercializacao.locacao.ativa'
    // verificando categoria
    switch(categoria){
      case "comprar":
        result = result.filter((im) => im.comercializacao.venda?.ativa == true && im.comercializacao.venda.preco);
        break;
      case "alugar":
        result = result.filter((im) => im.comercializacao.locacao?.ativa == true && im.comercializacao.locacao.preco);
        break;
      default:
        result = result;
        break;
    }


    return result;
  }

  private dataFilter(data: Array<Imovel>, condicao: (imovel: Imovel) => boolean): Imovel[] {
    return data.filter(condicao);
  }

  private verifyParams(imoveis: Array<Imovel>): Array<Imovel> {
    let filteredImoveis: Array<Imovel> = imoveis;

    if (this.params?.query && this.params?.query.trim() !== ''){
      const queryLower = this.params.query.toLowerCase();
      console.log(queryLower)
      filteredImoveis = this.dataFilter(filteredImoveis, (imovel: Imovel) => (
        imovel.local.bairro?.toLowerCase().includes(queryLower) ||
        imovel.local.cidade?.toLowerCase().includes(queryLower) ||
        imovel.local.rua?.toLowerCase().includes(queryLower) ||
        imovel.local.condominio?.toLowerCase().includes(queryLower) ||
        imovel.sigla?.toLowerCase() === queryLower
      ));
    }

    // filtrar preço
    if (this.params?.preco_min && this.params?.preco_min !== null){
      const preco: number = Number(this.params?.preco_min);
      if (this.params?.categoria === 'alugar'){
        filteredImoveis = this.dataFilter(filteredImoveis, (imovel: Imovel) => imovel.comercializacao.locacao.preco >= preco);
      } else {
        filteredImoveis = this.dataFilter(filteredImoveis, (imovel: Imovel) => imovel.comercializacao.venda.preco >= preco);
      }
    }
    if (this.params?.preco_max && this.params?.preco_max !== null){
      const preco: number = Number(this.params?.preco_max);
      if (this.params?.categoria === 'alugar'){
        filteredImoveis = this.dataFilter(filteredImoveis, (imovel: Imovel) => imovel.comercializacao.locacao.preco <= preco);
      } else {
        filteredImoveis = this.dataFilter(filteredImoveis, (imovel: Imovel) => imovel.comercializacao.venda.preco <= preco);
      }
    }

    // filtrar por area
    if (this.params?.area_min && this.params?.area_min !== null){
      const area: number = Number(this.params?.area_min);
      filteredImoveis = this.dataFilter(filteredImoveis, (imovel: Imovel) => (
        (imovel.tipo == 'casa' && imovel.numeros.areas.total >= area) ||
        ((imovel.tipo === 'apartamento' || imovel.tipo === 'sala' || imovel.tipo === 'cobertura') && imovel.numeros.areas.util >= area) ||
        ((imovel.tipo === 'terreno' || imovel.tipo === 'chácara') && imovel.numeros.areas.terreno >= area) ||
        ((imovel.tipo === 'galpão' || imovel.tipo === 'prédio') && imovel.numeros.areas.construida >= area)
      ));
    }

    if (this.params?.area_max && this.params?.area_max !== null){
      const area: number = Number(this.params?.area_max);
      filteredImoveis = this.dataFilter(filteredImoveis, (imovel: Imovel) => (
        (imovel.tipo == 'casa' && imovel.numeros.areas.total <= area) ||
        ((imovel.tipo === 'apartamento' || imovel.tipo === 'sala' || imovel.tipo === 'cobertura') && imovel.numeros.areas.util <= area) ||
        ((imovel.tipo === 'terreno' || imovel.tipo === 'chácara') && imovel.numeros.areas.terreno <= area) ||
        ((imovel.tipo === 'galpão' || imovel.tipo === 'prédio') && imovel.numeros.areas.construida <= area)
      ));
    }

    // filtra dormitórios
    if (this.params?.dormitorios && this.params?.dormitorios !== null){
      const num: number = Number(this.params?.dormitorios);
      let func: (imovel: Imovel) => boolean = (imovel: Imovel): boolean => imovel.numeros.dormitorios == num;
      if (num == 4){
        func = (imovel: Imovel): boolean => imovel.numeros.dormitorios >= num;
      }
      filteredImoveis = this.dataFilter(filteredImoveis, func);
    }

    // filtra banheiros
    if (this.params?.banheiros && this.params?.banheiros !== null){
      const num: number = Number.parseInt(this.params?.banheiros);
      let func: (imovel: Imovel) => boolean = (imovel: Imovel): boolean => imovel.numeros.banheiros == num;
      if (num == 4){
        func = (imovel: Imovel): boolean => imovel.numeros.banheiros >= num;
      }
      filteredImoveis = this.dataFilter(filteredImoveis, func);
    }

    // filtrar garagens
    if (this.params?.garagem && this.params?.garagem !== null){
      const num: number = Number.parseInt(this.params?.garagem);
      let func: (imovel: Imovel) => boolean = (imovel: Imovel): boolean => imovel.numeros.vagas == num;
      if (num == 4){
        func = (imovel: Imovel): boolean => imovel.numeros.vagas >= num;
      }
      filteredImoveis = this.dataFilter(filteredImoveis, func);
    }

    if(this.params?.tipos && this.params?.tipos.length > 0){
      filteredImoveis = this.dataFilter(filteredImoveis, (imovel:Imovel) => {
        return this.params.tipos.includes(imovel.tipo);
      })
    }

    if(this.params.order && this.params.order === "price"){
      if(this.params?.categoria && (this.params?.categoria === "comprar" || this.params?.categoria === "alugar")){
        let key = "venda";
        if(this.params?.categoria === "alugar") key = "locacao";
        filteredImoveis = [...filteredImoveis].sort((a, b) => a.comercializacao[key].preco - b.comercializacao[key].preco)
      } else {
        filteredImoveis = [...filteredImoveis].sort((a, b) => {
          const imovel1 = a.comercializacao.venda.ativa ? a.comercializacao.venda.preco : a.comercializacao.locacao.preco;
          const imovel2 = b.comercializacao.venda.ativa ? b.comercializacao.venda.preco : b.comercializacao.locacao.preco;

          return imovel1 - imovel2;
        })
      }
    }



    return filteredImoveis;
  }
  

  // queryChange(p) {
  //   this.queryParams = p;
  //   // custom search
  //   this.customSearch.customSearch.categoria = this.queryParams?.categoria || 'comprar';
  //   this.customSearch.customSearch.salas = this.queryParams?.salas || 0;
  //   this.customSearch.customSearch.garagem = this.queryParams?.garagem || 0;
  //   this.customSearch.customSearch.dormitorios = this.queryParams?.dormitorios || 0;
  //   this.customSearch.customSearch.banheiros = this.queryParams?.banheiros || 0;
  //   this.customSearch.customSearch.cidade = this.queryParams?.cidade || '';
  //   this.customSearch.customSearch.bairros = this.queryParams?.bairros || '';
  //   this.customSearch.customSearch.tipos = _.isArray(this.queryParams?.tipos) ? this.queryParams?.tipos : (this.queryParams?.tipos ? [this.queryParams?.tipos] : '');
  //   this.customSearch.customSearch.precos = this.queryParams?.precos || '';
  //   // end custom search

  //   // sidebar
  //   // this.searchSidebar.customSearch.categoria = this.queryParams?.categoria || 'comprar';
  //   // this.searchSidebar.customSearch.salas = this.queryParams?.salas || 0;
  //   // this.searchSidebar.customSearch.garagem = this.queryParams?.garagem || 0;
  //   // this.searchSidebar.customSearch.dormitorios = this.queryParams?.dormitorios || 0;
  //   // this.searchSidebar.customSearch.banheiros = this.queryParams?.banheiros || 0;
  //   // this.searchSidebar.customSearch.cidade = this.queryParams?.cidade || '';
  //   // this.searchSidebar.customSearch.bairros = this.queryParams?.bairros || '';
  //   // this.searchSidebar.customSearch.tipos = _.isArray(this.queryParams?.tipos) ? this.queryParams?.tipos : (this.queryParams?.tipos ? [this.queryParams?.tipos] : '');
  //   // this.searchSidebar.customSearch.precos = this.queryParams?.precos || '';
  //   // end sidebar



  //   if (this.queryParams.finalidade) {
  //     this.customSearch.customSearch.finalidade = this.queryParams?.finalidade;
  //     this.searchSidebar.customSearch.finalidade = this.queryParams?.finalidade;
  //   }
  //   this.customSearch.customSearch.page = this.queryParams?.page || 1;
  //   this.searchSidebar.customSearch.page = this.queryParams?.page || 1;
  //   try {
  //     this.currentPage = parseInt(localStorage.getItem(location.search) || '1', 0);
  //   } catch (e) {
  //     console.error(e);
  //     this.currentPage = 1;
  //   }
  //   this.buildBadges();
  //   this.getImoveis();
  //   this.scrollTop();

  // }

  openFilter() {
    this.customSearch.type = CustomSearchType.complex;
    this.customSearch.showMe = true;
  }

  goImovel(imovel: Imovel) {
    try {
      localStorage.setItem(nextscroll, String(window.scrollY));
      localStorage.setItem(nextLastAllImoveis, JSON.stringify(this.allImoveis));
      localStorage.setItem(nextLastImoveis, JSON.stringify(this.imoveis));
      localStorage.setItem(nextQueryParams, JSON.stringify(this.queryParams));
      localStorage.setItem(nextCurrentPage, String(this.currentPage));
    } catch (e) {
      console.error(e);
    }
    this.router.navigate(['/imoveis/' + imovel.sigla]).then();
  }

  ngAfterViewInit(): void {
    
    this.cdr.detectChanges();
    // try {
    //   if (localStorage.getItem(nextLastAllImoveis)) {
    //     this.allImoveis = JSON.parse(localStorage.getItem(nextLastAllImoveis));
    //     this.imoveis = JSON.parse(localStorage.getItem(nextLastImoveis));
    //   }
    //   localStorage.removeItem(nextLastAllImoveis);
    //   localStorage.removeItem(nextLastImoveis);
    // } catch (e) {
    //   console.error(e);
    // }
    // this.route.data.subscribe(data => {
    //   if (data?.breadcrumbTitle) {
    //     this.breadcrumbTitle = data.breadcrumbTitle;
    //   } else {
    //     this.breadcrumbTitle = null;
    //   }
    //   this.backing = data?.backing || false;

    //   if (this.backing) {
    //     setTimeout(() => {
    //       this.backing = false;
    //       const c = parseInt(localStorage.getItem('nextCurrentPage'), 0);
    //       this.currentPage = c;
    //       if (c === 0) {
    //         this.currentPage = 1;
    //       }
    //       localStorage.removeItem('nextCurrentPage');
    //       this.makeResults(this.allImoveis, null, true);
    //       this.makePagination();
    //       this.buildBadges();
    //     }, 200);
    //   }
    // });
  }

  // badgeClose(param: any) {
  //   const ss = param.split(',');
  //   if (ss?.length > 0) {
  //     switch (ss[0]) {
  //       case 'categoria':
  //         this.customSearch.customSearch.categoria = null;
  //         this.searchSidebar.customSearch.categoria = null;
  //         break;
  //       case 'finalidade':
  //         this.customSearch.customSearch.categoria = null;
  //         this.searchSidebar.customSearch.categoria = null;
  //         break;
  //       case 'bairros':
  //         this.customSearch.bairrosSelecionados = this.customSearch.bairrosSelecionados.filter(value1 => value1 !== ss[1]);
  //         this.searchSidebar.bairrosSelecionados = this.searchSidebar.bairrosSelecionados.filter(value1 => value1 !== ss[1]);
  //         break;
  //       case 'cidade':
  //         this.customSearch.customSearch.cidade = null;
  //         this.searchSidebar.customSearch.cidade = null;
  //         break;
  //       case 'dormitorios':
  //         this.customSearch.customSearch.dormitorios = 0;
  //         this.searchSidebar.customSearch.dormitorios = 0;
  //         break;
  //       case 'banheiros':
  //         this.customSearch.customSearch.banheiros = 0;
  //         this.searchSidebar.customSearch.banheiros = 0;
  //         break;
  //       case 'garagem':
  //         this.customSearch.customSearch.garagem = 0;
  //         this.searchSidebar.customSearch.garagem = 0;
  //         break;
  //       case 'tipo':
  //         this.customSearch.tiposSelecionados = this.customSearch.tiposSelecionados.filter(value1 => value1 !== ss[1]);
  //         this.searchSidebar.tiposSelecionados = this.searchSidebar.tiposSelecionados.filter(value1 => value1 !== ss[1]);
  //         break;
  //       case 'precos':
  //         this.customSearch.customSearch.precos = {
  //           min: null,
  //           max: null,
  //         };
  //         this.searchSidebar.customSearch.precos = {
  //           min: null,
  //           max: null,
  //         };
  //         break;
  //       case 'area':
  //         this.customSearch.customSearch.area = {
  //           min: null,
  //           max: null,
  //         };
  //         this.searchSidebar.customSearch.area = {
  //           min: null,
  //           max: null,
  //         };
  //         break;

  //     }
  //   }


  //   // @ts-ignore
  //   this.customSearch?.forceSearch = !this.customSearch?.forceSearch;
  //   this.searchSidebar.forceSearch = !this.searchSidebar?.forceSearch;
  // }

  changeOrder(e:Event){
    this.router.navigate(
      [], {
        queryParams: {
          ...this.params,
          order: this.order
        }
      }
    );
  }

  changePage(page: number): void {

    this.router.navigate(
      ['/imoveis/'], {
        queryParams: {
          ...this.params,
          page:page
        }
      }
    );
    scroll({ top: 0 });

    // if (page) {
    //   if (this.currentPage + page <= 0) {
    //     return;
    //   }
    //   // this.scrollTop();
    //   this.currentPage = page;
    //   this.customSearch.customSearch.page = page;
    //   this.searchSidebar.customSearch.page = page;
    //   // this.makePagination();
    //   try {
    //     localStorage.setItem(location.search, page.toString());
    //   } catch (e) {
    //     console.error(e);
    //   }
    // }
  }

  // private checkResults() {
  //   if ((!this.imoveis || this.imoveis.length === 0) && (!this.allImoveis || this.allImoveis.length === 0)) {
  //   } else if (this.imoveis.length === 1 && Object.keys(this.queryParams).length === 1 && this.queryParams.query) {
  //     this.router.navigateByUrl('/imoveis/' + this.imoveis[0].sigla).then();
  //   }
  // }

  imagensCarousel(images: string[]) {
    return _.slice(images, 0, 4);
  }

  doSimpleSearch() {
    // this.route.queryParams.subscribe(paramsObject => {
    //   const params = paramsObject;
    //   let restQueryObject:any = {};
    //   for(const [key, value] of Object.entries(params)){
    //     restQueryObject[key] = value;
    //   }

    //   this.router.navigate(
    //     ['/imoveis/'], {
    //       queryParams:{
    //         query: this.simpleSearch,
    //         ...restQueryObject,
    //       }
    //     })
    // });
    // if (this.simpleSearch?.length > 0) {
    //   if (this.autocompleteSelected?.type === 'sigla') {
    //     this.router.navigate(['imoveis', this.autocompleteSelected?.value]).then();
    //   } else {
    //     this.router.navigate(['imoveis'], {
    //       queryParams: {
    //         query: this.simpleSearch,
    //         autocomplete: this.autocompleteSelected?.type
    //       }
    //     }).then();
    //   }
    // }
  }

  // private scrollTop() {
  //   try {
  //     window.scrollTo({left: 0, top: 0, behavior: 'smooth'});
  //   } catch (e) {
  //     window.scrollTo(0, 0);
  //   }
  // }

  getprice(imovel: Imovel): string {
    if (!imovel) {
      return '?';
    }
    try {
      if (this.queryParams.categoria === 'comprar') {
        if (imovel.comercializacao.venda && imovel.comercializacao.venda.ativa) {
          return this.getFormattedPrice(imovel.comercializacao.venda.preco);
        }
      } else if (this.queryParams.categoria === 'alugar') {
        if (imovel.comercializacao.locacao && imovel.comercializacao.locacao.ativa) {
          return this.getFormattedPrice(imovel.comercializacao.locacao.preco);
        }
      } else {
        if (imovel.comercializacao.locacao && imovel.comercializacao.locacao.ativa) {
          return this.getFormattedPrice(imovel.comercializacao.locacao.preco);
        } else if (imovel.comercializacao.venda && imovel.comercializacao.venda.ativa) {
          return this.getFormattedPrice(imovel.comercializacao.venda.preco);
        }
      }
    } catch (e) {
    }
    return '?';
  }

  // buildBadges() {
  //   try {
  //     if (localStorage.getItem(nextQueryParams)) {
  //       this.queryParams = JSON.parse(localStorage.getItem(nextQueryParams));
  //     }
  //     localStorage.removeItem(nextQueryParams);
  //   } catch (e) {
  //     console.error(e);
  //   }
  //   this.badges = [];

  //   if (this.queryParams?.bairros) {
  //     const ss = typeof this.queryParams?.bairros?.split === 'function' ? (this.queryParams?.bairros?.split(',') || []) : this.queryParams?.bairros;


  //     ss.forEach(b => {
  //       this.badges.push(this.badge(`No bairro: ${b}`, `bairros,${b}`))
  //     });

  //     // console.log("verificando: ", this.route.snapshot.queryParams.bairros)
  //     if (ss.length === 0 && this.route.snapshot.queryParams.bairros) {
  //       this.route.snapshot.queryParams.bairros.forEach(b => this.badges.push(this.badge(`No bairro: ${b}`, `bairros,${b}`)));
  //     }

  //   }

  //   if (this.queryParams.cidade) {
  //     this.badges.push(this.badge(`Na cidade de ${this.queryParams.cidade}`, 'cidade'));
  //   }

  //   if (this.queryParams.dormitorios) {
  //     const n = Number(this.queryParams.dormitorios);
  //     if (n === 1) {
  //       this.badges.push(this.badge(`Com ${n} dormitório`, 'dormitorios'));
  //     } else if (n === 4) {
  //       this.badges.push(this.badge(`Com ${n} ou mais dormitórios`, 'dormitorios'));
  //     } else if (n !== 0) {
  //       this.badges.push(this.badge(`Com ${n}  dormitórios`, 'dormitorios'));
  //     }

  //   }

  //   if (this.queryParams.banheiros) {
  //     const n = Number(this.queryParams.banheiros);
  //     if (n === 1) {
  //       this.badges.push(this.badge(`Com ${n} banheiro`, 'banheiros'));
  //     } else if (n === 4) {
  //       this.badges.push(this.badge(`Com ${n} ou mais banheiros`, 'banheiros'));
  //     } else if (n !== 0) {
  //       this.badges.push(this.badge(`Com ${n}  banheiros`, 'banheiros'));
  //     }

  //   }


  //   if (this.queryParams.garagem) {
  //     const n = Number(this.queryParams.garagem);
  //     if (n === 1) {
  //       this.badges.push(this.badge(`Com ${n} vaga de garagem`, 'garagem'));
  //     } else if (n === 4) {
  //       this.badges.push(this.badge(`Com ${n} ou mais vagas de garagem`, 'garagem'));
  //     } else if (n !== 0) {
  //       this.badges.push(this.badge(`Com ${n}  vagas de garagem`, 'garagem'));
  //     }

  //   }

  //   if (this.queryParams.tipos) {
  //     const ss = typeof this.queryParams?.tipos?.split === 'function' ?
  //       (this.queryParams?.tipos?.split(',') || []) : this.queryParams?.tipos;
  //     ss.forEach(b => this.badges.push(this.badge(`Tipo: ${b}`, `tipo,${b}`)));
  //   }

  //   if (this.queryParams.precos?.min || this.queryParams.precos?.max) {
  //     if (this.queryParams.precos?.min && this.queryParams.precos?.max) {
  //       const spMin = formatCurrency(Number(this.queryParams.precos?.min), 'pt-BR', 'R$', 'BRL');
  //       const spMax = formatCurrency(Number(this.queryParams.precos?.max), 'pt-BR', 'R$', 'BRL');
  //       this.badges.push(this.badge(`Entre: ${spMin} e ${spMax}`, 'precos'));
  //     } else if (this.queryParams.precos?.min) {
  //       const spMin = formatCurrency(Number(this.queryParams.precos?.min), 'pt-BR', 'R$', 'BRL');
  //       this.badges.push(this.badge(`Preço maior que ${spMin}`, 'precos'));
  //     } else if (this.queryParams.precos?.max) {
  //       const spMax = formatCurrency(Number(this.queryParams.precos?.max), 'pt-BR', 'R$', 'BRL');
  //       this.badges.push(this.badge(`Preço manor que ${spMax}`, 'precos'));
  //     }
  //   }

  //   if (this.queryParams.area?.min || this.queryParams.area?.max) {
  //     if (this.queryParams.area?.min && this.queryParams.area?.max) {
  //       const spMin = new DecimalPipe('pt-BR').transform(this.queryParams.area?.min);
  //       const spMax = new DecimalPipe('pt-BR').transform(this.queryParams.area?.max);
  //       this.badges.push(this.badge(`Com área entre: ${spMin} m² e ${spMax} m²`, 'area'));
  //     } else if (this.queryParams.area?.min) {
  //       const spMin = new DecimalPipe('pt-BR').transform(this.queryParams.area?.min);
  //       this.badges.push(this.badge(`Área maior que ${spMin} m²`, 'area'));
  //     } else if (this.queryParams.area?.max) {
  //       const spMax = new DecimalPipe('pt-BR').transform(this.queryParams.area?.max);
  //       this.badges.push(this.badge(`Área manor que ${spMax} m²`, 'area'));
  //     }
  //   }

  // }

  // private badge(s: string, query: string): any {
  //   return {label: s, query};
  // }

  softParamSearch(event: any) {
    // if (event.autocomplete) {
    //   switch (event.autocomplete) {
    //     case 'bairro':
    //       this.all.getImoveisByBairro(event.query)
    //         .subscribe((value) => {
    //           this.makeResults(value as Imovel[]);
    //         });
    //       break;
    //     case 'cidade':
    //       this.all.getImoveisByCidade(event.query + '/SP')
    //         .subscribe((value) => {
    //           this.makeResults(value as Imovel[], event);
    //         });
    //       break;
    //   }
    // } else if (event.finalidade && event.categoria) {
    //   this.all.getImoveisByFinalidadeTipo(event.finalidade, event.categoria)
    //     .subscribe((value) => {
    //       this.makeResults(value as Imovel[], event);
    //     });

    // } else if (event.destaques) {
    //   this.all.getImoveisDestaque()
    //     .subscribe((value) => {
    //       this.makeResults(value as Imovel[], event);
    //     });

    // }
  }

  // searchAutocomplete(event: any) {
  //   const datalist = document.querySelectorAll('.imoveisDatalist')[0];
  //   if (this.simpleSearch.length > 3) {
  //     datalist.id = 'dynmicUserIdsImoveis';
  //   } else {
  //     this.autocompleteSelected = null;
  //     datalist.id = '';
  //   }

  // }

  showMobile:boolean = false;
  // // @ViewChild('searchMobile') searchMobile:MobileSearchComponent;
  openMobileSearch(){
    if (window.innerWidth <= 991){
      this.showMobile = !this.showMobile;
    }
  }

  inputMobileSearch(newSimpleSearch:string){
    this.simpleSearch = newSimpleSearch;
    // console.log(newSimpleSearch)
  }

  selectedSearchOption(value:string):void{
    this.simpleSearch = value;
  }

  onSelectAutoComplete(e: any, value: string) {
    if (value === null || value === undefined) return;
    if (value.trim() === "") return;

    const lowerValue = value.toLowerCase();

    if (value.length >= 3){
      const cidades: IAutoComplete[] = this.filterLocales(lowerValue, 'cidade');
      const bairros: IAutoComplete[] = this.filterLocales(lowerValue, 'bairro');
      const condominios: IAutoComplete[] = this.filterLocales(lowerValue, 'condominio');
      const ruas: IAutoComplete[] = this.filterLocales(lowerValue, 'rua');

      const cidadesUnicas = Array.from(new Map(cidades.map(item => [item.value.toLowerCase(), item])).values());
      const bairrosUnicos = Array.from(new Map(bairros.map(item => [item.value.toLowerCase(), item])).values());
      const condominiosUnicos = Array.from(new Map(condominios.map(item => [item.value.toLowerCase(), item])).values());
      const ruasUnicas = Array.from(new Map(ruas.map(item => [item.value.toLowerCase(), item])).values());

      this.bairrosAndCidades = {
        visible: (bairros.length > 0 || cidades.length > 0 || ruas.length > 0 || condominios.length > 0),
        bairros: bairrosUnicos,
        cidades: cidadesUnicas,
        condominios: condominiosUnicos,
        ruas: ruasUnicas
      };
    } else {
      this.bairrosAndCidades = {
        visible: false,
        bairros: [],
        cidades: [],
        condominios: [],
        ruas: []
      };
    }

    this.autocompleteSelected = this.autocompletes.find(item => item.value === value);
  }

  private filterLocales(value: string, type: string): IAutoComplete[] {
    let filterCategorie: IAutoComplete[] = this.autocompletes;
    // console.log(this.params);
    if (this.params.categoria) {
      filterCategorie = this.autocompletes.filter((imovel) => {
        if (this.params.categoria === 'comprar'){
          return imovel.venda === true;
        } else {
          return imovel.locacao === true;
        }
      });
    }
    if (this.params.finalidade){
      filterCategorie = this.autocompletes.filter((imovel) => imovel.finalidade === this.params.finalidade);
    }
    return filterCategorie.filter(item =>
      item.type === type && item.value.toLowerCase().includes(value)
    ) || [];
  }

  // private loadDefaults() {
  //   docSnapshots(doc(this.firestore, `${PATH_AUTOCOMPLETE}/${PATH_AUTOCOMPLETE}`))
  //     .pipe(map((a) => {
  //       return a.data();
  //     }))
  //     .subscribe((strings) => {
  //       this.autocompletes = _.unionBy(strings.autocomplete, 'value');
  //     });
  // }

  // private getImoveis(query?: any, last?: Imovel) {
  //   try {
  //     this.all.getImoveis(query || this.searchSidebar?.customSearch || this.customSearch?.customSearch, last)
  //       ?.subscribe((value) => {
  //         this.makeResults(value as Imovel[]);
  //       });
  //   } catch (e) {
  //     console.error(e);
  //     this.all.getImoveis(query || this.searchSidebar?.customSearch || this.customSearch?.customSearch, last)
  //       ?.subscribe((value) => {
  //         this.makeResults(value as Imovel[]);
  //       });
  //   }
  // }

  // private makeResults(value: Imovel[], event: any = null, backing = false) {
  //   if (event && (event.finalidade || event.categoria)) {
  //     if (event.finalidade) {
  //       value = _.filter(value, (v) => v.finalidade === event.finalidade);
  //     }

  //     if (event.categoria) {
  //       value = _.filter(value, (v) => event.categoria === 'comprar' ? v.comercializacao?.venda?.ativa : v.comercializacao?.locacao?.ativa);
  //     }
  //   }
  //   this.allImoveis = value;
  //   this.pages = this.allImoveis?.length || 0;
  //   this.makePagination();
  //   if (this.queryParams.query) {
  //     const findBySigla = this.imoveis.find(value1 => value1.sigla === this.queryParams.query);
  //     if (findBySigla) {
  //       this.goImovel(findBySigla);
  //     }
  //   }
  //   this.checkResults();
  //   setTimeout(() => {
  //     try {
  //       window.scrollTo(0, parseInt(localStorage.getItem('nextscroll'), 0));
  //       localStorage.removeItem('nextscroll');
  //     } catch (e) {
  //       console.error(e);
  //     }
  //   }, 500);

  // }

  // private makePagination() {
  //   this.initializeResults = true;
  //   this.imoveis = _.slice(this.allImoveis, 10 * (this.currentPage - 1), 10 * (this.currentPage - 1) + 10);
  // }


  // logn search

  logn_search_input(): void{
    if (this.simpleSearch.trim() !== ""){
      // this.params = {
      //   ...params,
      //   ...(tipos.length > 0 && { tipos })
      // };
      const query: {finalidade?: string, categoria?: string } = {
        ...(this.params?.finalidade && { finalidade: this.params?.finalidade }),
        ...((this.params?.categoria || this.category) && { categoria: this.category })
      };
      this.router.navigate(['/imoveis'],{
        queryParams: { ...query, query: this.simpleSearch }
      });
      scroll({ top: 0 });
    }
  }

  // private logn_search(){
  //   this.logn_formInputValues();
  //   this.all.getImoveisFilter(this.params).pipe(take(1)).subscribe((result: Imovel[]) => {

  //     const storage: string = localStorage.getItem("results");
  //     const objStorage = JSON.parse(storage) || {};

  //     this.collectionSize = result.length;
  //     this.currentPage = (objStorage?.page) ? Number(objStorage.page) : 1;
  //     this.pages = Math.ceil(result.length / this.limitPosts);
  //     const init: number = (this.currentPage * this.limitPosts) - this.limitPosts;
  //     this.imoveis = result.slice(init, init + this.limitPosts);
  //     this.initializeResults = this.imoveis.length === 0;

  //     setTimeout(()=> {
  //       const scrollPosition:null | string = localStorage.getItem(nextscroll);
  //       if(scrollPosition){
  //         const top:number = Number.parseInt(scrollPosition);
  //         scroll({
  //           top
  //         })
  //         localStorage.removeItem(nextscroll);
  //       }
  //     }, 300)
  //   });
  // }

  private logn_formInputValues(){
    // @ViewChild('customSearch') customSearch: CustomSearchComponent;
    // @ViewChild('searchSidebar') searchSidebar: SearchSidebarComponent;

    if (this.params?.query){
      this.simpleSearch = this.params.query;
    }

    if (this.params?.tipos){
      this.customSearch.tiposSelecionados = this.params.tipos;
      this.searchSidebar.tiposSelecionados = this.params.tipos;
    }

    if (this.params?.preco_min){
      this.customSearch.customSearch.precos.min = this.params.preco_min;
      this.searchSidebar.customSearch.precos.min = this.params.preco_min;
    }

    if (this.params?.preco_max){
      this.customSearch.customSearch.precos.max = this.params.preco_max;
      this.searchSidebar.customSearch.precos.max = this.params.preco_max;
    }

    if (this.params?.area_min){
      this.customSearch.customSearch.area.min = this.params.area_min;
      this.searchSidebar.customSearch.area.min = this.params.area_min;
    }

    if (this.params?.area_max){
      this.customSearch.customSearch.area.max = this.params.area_max;
      this.searchSidebar.customSearch.area.max = this.params.area_max;
    }

    if (this.params?.dormitorios){
      this.customSearch.customSearch.dormitorios = this.params.dormitorios;
      this.searchSidebar.customSearch.dormitorios = this.params.dormitorios;
    }

    if (this.params?.banheiros){
      this.customSearch.customSearch.banheiros = this.params.banheiros;
      this.searchSidebar.customSearch.banheiros = this.params.banheiros;
    }

    if (this.params?.garagem){
      this.customSearch.customSearch.garagem = this.params.garagem;
      this.searchSidebar.customSearch.garagem = this.params.garagem;
    }
  }

  logn_formatPrice(imovel: Imovel): string{
    let convertToNumber: number;

    if(this.params?.categoria){
      if (this.params.categoria === 'comprar'){
        convertToNumber = imovel?.comercializacao.venda.preco;
      } else {
        convertToNumber = imovel?.comercializacao.locacao.preco;
      }
    } else {
      if(imovel.comercializacao.venda.ativa){
        convertToNumber = imovel?.comercializacao.venda.preco
      } else {
        convertToNumber = imovel?.comercializacao.locacao.preco
      }
    }

    return new Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(convertToNumber);
  }


  ngOnDestroy():void{
    this.subQuery.unsubscribe();
    this.subImoveis.unsubscribe();
  }

}
